/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedAdminRouteImport } from './routes/_authed/admin'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedOrganizationsOrgIdRouteImport } from './routes/_authed/organizations/$orgId'
import { Route as AuthedAdminUsersRouteImport } from './routes/_authed/admin/users'
import { Route as AuthedAdminOrganizationsRouteImport } from './routes/_authed/admin/organizations'
import { Route as AuthedOrganizationsOrgIdIndexRouteImport } from './routes/_authed/organizations/$orgId/index'
import { Route as AuthedAdminUsersIndexRouteImport } from './routes/_authed/admin/users.index'
import { Route as AuthedAdminOrganizationsIndexRouteImport } from './routes/_authed/admin/organizations.index'
import { Route as AuthedOrganizationsOrgIdProspectsByGivingLevelRouteImport } from './routes/_authed/organizations/$orgId/prospects-by-giving-level'
import { Route as AuthedOrganizationsOrgIdProspectsByEngagementRouteImport } from './routes/_authed/organizations/$orgId/prospects-by-engagement'
import { Route as AuthedOrganizationsOrgIdProspectsByCapacityRouteImport } from './routes/_authed/organizations/$orgId/prospects-by-capacity'
import { Route as AuthedOrganizationsOrgIdProspectsRouteImport } from './routes/_authed/organizations/$orgId/prospects'
import { Route as AuthedOrganizationsOrgIdGapAnalysisRouteImport } from './routes/_authed/organizations/$orgId/gap-analysis'
import { Route as AuthedOrganizationsOrgIdConversionByEngagementLevelRouteImport } from './routes/_authed/organizations/$orgId/conversion-by-engagement-level'
import { Route as AuthedOrganizationsOrgIdAssignedVsUnassignedRouteImport } from './routes/_authed/organizations/$orgId/assigned-vs-unassigned'
import { Route as AuthedAdminUsersUserIdRouteImport } from './routes/_authed/admin/users.$userId'
import { Route as AuthedAdminOrganizationsOrgIdRouteImport } from './routes/_authed/admin/organizations.$orgId'
import { Route as AuthedAdminOrganizationsOrgIdIndexRouteImport } from './routes/_authed/admin/organizations.$orgId.index'
import { Route as AuthedAdminOrganizationsOrgIdDataRouteImport } from './routes/_authed/admin/organizations.$orgId.data'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedOrganizationsOrgIdRoute =
  AuthedOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAdminUsersRoute = AuthedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminOrganizationsRoute =
  AuthedAdminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedOrganizationsOrgIdIndexRoute =
  AuthedOrganizationsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedAdminUsersIndexRoute = AuthedAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminUsersRoute,
} as any)
const AuthedAdminOrganizationsIndexRoute =
  AuthedAdminOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminOrganizationsRoute,
  } as any)
const AuthedOrganizationsOrgIdProspectsByGivingLevelRoute =
  AuthedOrganizationsOrgIdProspectsByGivingLevelRouteImport.update({
    id: '/prospects-by-giving-level',
    path: '/prospects-by-giving-level',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdProspectsByEngagementRoute =
  AuthedOrganizationsOrgIdProspectsByEngagementRouteImport.update({
    id: '/prospects-by-engagement',
    path: '/prospects-by-engagement',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdProspectsByCapacityRoute =
  AuthedOrganizationsOrgIdProspectsByCapacityRouteImport.update({
    id: '/prospects-by-capacity',
    path: '/prospects-by-capacity',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdProspectsRoute =
  AuthedOrganizationsOrgIdProspectsRouteImport.update({
    id: '/prospects',
    path: '/prospects',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdGapAnalysisRoute =
  AuthedOrganizationsOrgIdGapAnalysisRouteImport.update({
    id: '/gap-analysis',
    path: '/gap-analysis',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdConversionByEngagementLevelRoute =
  AuthedOrganizationsOrgIdConversionByEngagementLevelRouteImport.update({
    id: '/conversion-by-engagement-level',
    path: '/conversion-by-engagement-level',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedOrganizationsOrgIdAssignedVsUnassignedRoute =
  AuthedOrganizationsOrgIdAssignedVsUnassignedRouteImport.update({
    id: '/assigned-vs-unassigned',
    path: '/assigned-vs-unassigned',
    getParentRoute: () => AuthedOrganizationsOrgIdRoute,
  } as any)
const AuthedAdminUsersUserIdRoute = AuthedAdminUsersUserIdRouteImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => AuthedAdminUsersRoute,
} as any)
const AuthedAdminOrganizationsOrgIdRoute =
  AuthedAdminOrganizationsOrgIdRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () => AuthedAdminOrganizationsRoute,
  } as any)
const AuthedAdminOrganizationsOrgIdIndexRoute =
  AuthedAdminOrganizationsOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedAdminOrganizationsOrgIdRoute,
  } as any)
const AuthedAdminOrganizationsOrgIdDataRoute =
  AuthedAdminOrganizationsOrgIdDataRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => AuthedAdminOrganizationsOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/admin/organizations': typeof AuthedAdminOrganizationsRouteWithChildren
  '/admin/users': typeof AuthedAdminUsersRouteWithChildren
  '/organizations/$orgId': typeof AuthedOrganizationsOrgIdRouteWithChildren
  '/admin/': typeof AuthedAdminIndexRoute
  '/admin/organizations/$orgId': typeof AuthedAdminOrganizationsOrgIdRouteWithChildren
  '/admin/users/$userId': typeof AuthedAdminUsersUserIdRoute
  '/organizations/$orgId/assigned-vs-unassigned': typeof AuthedOrganizationsOrgIdAssignedVsUnassignedRoute
  '/organizations/$orgId/conversion-by-engagement-level': typeof AuthedOrganizationsOrgIdConversionByEngagementLevelRoute
  '/organizations/$orgId/gap-analysis': typeof AuthedOrganizationsOrgIdGapAnalysisRoute
  '/organizations/$orgId/prospects': typeof AuthedOrganizationsOrgIdProspectsRoute
  '/organizations/$orgId/prospects-by-capacity': typeof AuthedOrganizationsOrgIdProspectsByCapacityRoute
  '/organizations/$orgId/prospects-by-engagement': typeof AuthedOrganizationsOrgIdProspectsByEngagementRoute
  '/organizations/$orgId/prospects-by-giving-level': typeof AuthedOrganizationsOrgIdProspectsByGivingLevelRoute
  '/admin/organizations/': typeof AuthedAdminOrganizationsIndexRoute
  '/admin/users/': typeof AuthedAdminUsersIndexRoute
  '/organizations/$orgId/': typeof AuthedOrganizationsOrgIdIndexRoute
  '/admin/organizations/$orgId/data': typeof AuthedAdminOrganizationsOrgIdDataRoute
  '/admin/organizations/$orgId/': typeof AuthedAdminOrganizationsOrgIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/': typeof AuthedIndexRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/admin/users/$userId': typeof AuthedAdminUsersUserIdRoute
  '/organizations/$orgId/assigned-vs-unassigned': typeof AuthedOrganizationsOrgIdAssignedVsUnassignedRoute
  '/organizations/$orgId/conversion-by-engagement-level': typeof AuthedOrganizationsOrgIdConversionByEngagementLevelRoute
  '/organizations/$orgId/gap-analysis': typeof AuthedOrganizationsOrgIdGapAnalysisRoute
  '/organizations/$orgId/prospects': typeof AuthedOrganizationsOrgIdProspectsRoute
  '/organizations/$orgId/prospects-by-capacity': typeof AuthedOrganizationsOrgIdProspectsByCapacityRoute
  '/organizations/$orgId/prospects-by-engagement': typeof AuthedOrganizationsOrgIdProspectsByEngagementRoute
  '/organizations/$orgId/prospects-by-giving-level': typeof AuthedOrganizationsOrgIdProspectsByGivingLevelRoute
  '/admin/organizations': typeof AuthedAdminOrganizationsIndexRoute
  '/admin/users': typeof AuthedAdminUsersIndexRoute
  '/organizations/$orgId': typeof AuthedOrganizationsOrgIdIndexRoute
  '/admin/organizations/$orgId/data': typeof AuthedAdminOrganizationsOrgIdDataRoute
  '/admin/organizations/$orgId': typeof AuthedAdminOrganizationsOrgIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/admin/organizations': typeof AuthedAdminOrganizationsRouteWithChildren
  '/_authed/admin/users': typeof AuthedAdminUsersRouteWithChildren
  '/_authed/organizations/$orgId': typeof AuthedOrganizationsOrgIdRouteWithChildren
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/admin/organizations/$orgId': typeof AuthedAdminOrganizationsOrgIdRouteWithChildren
  '/_authed/admin/users/$userId': typeof AuthedAdminUsersUserIdRoute
  '/_authed/organizations/$orgId/assigned-vs-unassigned': typeof AuthedOrganizationsOrgIdAssignedVsUnassignedRoute
  '/_authed/organizations/$orgId/conversion-by-engagement-level': typeof AuthedOrganizationsOrgIdConversionByEngagementLevelRoute
  '/_authed/organizations/$orgId/gap-analysis': typeof AuthedOrganizationsOrgIdGapAnalysisRoute
  '/_authed/organizations/$orgId/prospects': typeof AuthedOrganizationsOrgIdProspectsRoute
  '/_authed/organizations/$orgId/prospects-by-capacity': typeof AuthedOrganizationsOrgIdProspectsByCapacityRoute
  '/_authed/organizations/$orgId/prospects-by-engagement': typeof AuthedOrganizationsOrgIdProspectsByEngagementRoute
  '/_authed/organizations/$orgId/prospects-by-giving-level': typeof AuthedOrganizationsOrgIdProspectsByGivingLevelRoute
  '/_authed/admin/organizations/': typeof AuthedAdminOrganizationsIndexRoute
  '/_authed/admin/users/': typeof AuthedAdminUsersIndexRoute
  '/_authed/organizations/$orgId/': typeof AuthedOrganizationsOrgIdIndexRoute
  '/_authed/admin/organizations/$orgId/data': typeof AuthedAdminOrganizationsOrgIdDataRoute
  '/_authed/admin/organizations/$orgId/': typeof AuthedAdminOrganizationsOrgIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/verify'
    | '/admin'
    | '/admin/organizations'
    | '/admin/users'
    | '/organizations/$orgId'
    | '/admin/'
    | '/admin/organizations/$orgId'
    | '/admin/users/$userId'
    | '/organizations/$orgId/assigned-vs-unassigned'
    | '/organizations/$orgId/conversion-by-engagement-level'
    | '/organizations/$orgId/gap-analysis'
    | '/organizations/$orgId/prospects'
    | '/organizations/$orgId/prospects-by-capacity'
    | '/organizations/$orgId/prospects-by-engagement'
    | '/organizations/$orgId/prospects-by-giving-level'
    | '/admin/organizations/'
    | '/admin/users/'
    | '/organizations/$orgId/'
    | '/admin/organizations/$orgId/data'
    | '/admin/organizations/$orgId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/verify'
    | '/'
    | '/admin'
    | '/admin/users/$userId'
    | '/organizations/$orgId/assigned-vs-unassigned'
    | '/organizations/$orgId/conversion-by-engagement-level'
    | '/organizations/$orgId/gap-analysis'
    | '/organizations/$orgId/prospects'
    | '/organizations/$orgId/prospects-by-capacity'
    | '/organizations/$orgId/prospects-by-engagement'
    | '/organizations/$orgId/prospects-by-giving-level'
    | '/admin/organizations'
    | '/admin/users'
    | '/organizations/$orgId'
    | '/admin/organizations/$orgId/data'
    | '/admin/organizations/$orgId'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/verify'
    | '/_authed/admin'
    | '/_authed/'
    | '/_authed/admin/organizations'
    | '/_authed/admin/users'
    | '/_authed/organizations/$orgId'
    | '/_authed/admin/'
    | '/_authed/admin/organizations/$orgId'
    | '/_authed/admin/users/$userId'
    | '/_authed/organizations/$orgId/assigned-vs-unassigned'
    | '/_authed/organizations/$orgId/conversion-by-engagement-level'
    | '/_authed/organizations/$orgId/gap-analysis'
    | '/_authed/organizations/$orgId/prospects'
    | '/_authed/organizations/$orgId/prospects-by-capacity'
    | '/_authed/organizations/$orgId/prospects-by-engagement'
    | '/_authed/organizations/$orgId/prospects-by-giving-level'
    | '/_authed/admin/organizations/'
    | '/_authed/admin/users/'
    | '/_authed/organizations/$orgId/'
    | '/_authed/admin/organizations/$orgId/data'
    | '/_authed/admin/organizations/$orgId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  VerifyRoute: typeof VerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/organizations/$orgId': {
      id: '/_authed/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/organizations/$orgId'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/users': {
      id: '/_authed/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthedAdminUsersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/organizations': {
      id: '/_authed/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthedAdminOrganizationsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/organizations/$orgId/': {
      id: '/_authed/organizations/$orgId/'
      path: '/'
      fullPath: '/organizations/$orgId/'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/admin/users/': {
      id: '/_authed/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthedAdminUsersIndexRouteImport
      parentRoute: typeof AuthedAdminUsersRoute
    }
    '/_authed/admin/organizations/': {
      id: '/_authed/admin/organizations/'
      path: '/'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AuthedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthedAdminOrganizationsRoute
    }
    '/_authed/organizations/$orgId/prospects-by-giving-level': {
      id: '/_authed/organizations/$orgId/prospects-by-giving-level'
      path: '/prospects-by-giving-level'
      fullPath: '/organizations/$orgId/prospects-by-giving-level'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdProspectsByGivingLevelRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/prospects-by-engagement': {
      id: '/_authed/organizations/$orgId/prospects-by-engagement'
      path: '/prospects-by-engagement'
      fullPath: '/organizations/$orgId/prospects-by-engagement'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdProspectsByEngagementRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/prospects-by-capacity': {
      id: '/_authed/organizations/$orgId/prospects-by-capacity'
      path: '/prospects-by-capacity'
      fullPath: '/organizations/$orgId/prospects-by-capacity'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdProspectsByCapacityRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/prospects': {
      id: '/_authed/organizations/$orgId/prospects'
      path: '/prospects'
      fullPath: '/organizations/$orgId/prospects'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdProspectsRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/gap-analysis': {
      id: '/_authed/organizations/$orgId/gap-analysis'
      path: '/gap-analysis'
      fullPath: '/organizations/$orgId/gap-analysis'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdGapAnalysisRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/conversion-by-engagement-level': {
      id: '/_authed/organizations/$orgId/conversion-by-engagement-level'
      path: '/conversion-by-engagement-level'
      fullPath: '/organizations/$orgId/conversion-by-engagement-level'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdConversionByEngagementLevelRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/organizations/$orgId/assigned-vs-unassigned': {
      id: '/_authed/organizations/$orgId/assigned-vs-unassigned'
      path: '/assigned-vs-unassigned'
      fullPath: '/organizations/$orgId/assigned-vs-unassigned'
      preLoaderRoute: typeof AuthedOrganizationsOrgIdAssignedVsUnassignedRouteImport
      parentRoute: typeof AuthedOrganizationsOrgIdRoute
    }
    '/_authed/admin/users/$userId': {
      id: '/_authed/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AuthedAdminUsersUserIdRouteImport
      parentRoute: typeof AuthedAdminUsersRoute
    }
    '/_authed/admin/organizations/$orgId': {
      id: '/_authed/admin/organizations/$orgId'
      path: '/$orgId'
      fullPath: '/admin/organizations/$orgId'
      preLoaderRoute: typeof AuthedAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof AuthedAdminOrganizationsRoute
    }
    '/_authed/admin/organizations/$orgId/': {
      id: '/_authed/admin/organizations/$orgId/'
      path: '/'
      fullPath: '/admin/organizations/$orgId/'
      preLoaderRoute: typeof AuthedAdminOrganizationsOrgIdIndexRouteImport
      parentRoute: typeof AuthedAdminOrganizationsOrgIdRoute
    }
    '/_authed/admin/organizations/$orgId/data': {
      id: '/_authed/admin/organizations/$orgId/data'
      path: '/data'
      fullPath: '/admin/organizations/$orgId/data'
      preLoaderRoute: typeof AuthedAdminOrganizationsOrgIdDataRouteImport
      parentRoute: typeof AuthedAdminOrganizationsOrgIdRoute
    }
  }
}

interface AuthedAdminOrganizationsOrgIdRouteChildren {
  AuthedAdminOrganizationsOrgIdDataRoute: typeof AuthedAdminOrganizationsOrgIdDataRoute
  AuthedAdminOrganizationsOrgIdIndexRoute: typeof AuthedAdminOrganizationsOrgIdIndexRoute
}

const AuthedAdminOrganizationsOrgIdRouteChildren: AuthedAdminOrganizationsOrgIdRouteChildren =
  {
    AuthedAdminOrganizationsOrgIdDataRoute:
      AuthedAdminOrganizationsOrgIdDataRoute,
    AuthedAdminOrganizationsOrgIdIndexRoute:
      AuthedAdminOrganizationsOrgIdIndexRoute,
  }

const AuthedAdminOrganizationsOrgIdRouteWithChildren =
  AuthedAdminOrganizationsOrgIdRoute._addFileChildren(
    AuthedAdminOrganizationsOrgIdRouteChildren,
  )

interface AuthedAdminOrganizationsRouteChildren {
  AuthedAdminOrganizationsOrgIdRoute: typeof AuthedAdminOrganizationsOrgIdRouteWithChildren
  AuthedAdminOrganizationsIndexRoute: typeof AuthedAdminOrganizationsIndexRoute
}

const AuthedAdminOrganizationsRouteChildren: AuthedAdminOrganizationsRouteChildren =
  {
    AuthedAdminOrganizationsOrgIdRoute:
      AuthedAdminOrganizationsOrgIdRouteWithChildren,
    AuthedAdminOrganizationsIndexRoute: AuthedAdminOrganizationsIndexRoute,
  }

const AuthedAdminOrganizationsRouteWithChildren =
  AuthedAdminOrganizationsRoute._addFileChildren(
    AuthedAdminOrganizationsRouteChildren,
  )

interface AuthedAdminUsersRouteChildren {
  AuthedAdminUsersUserIdRoute: typeof AuthedAdminUsersUserIdRoute
  AuthedAdminUsersIndexRoute: typeof AuthedAdminUsersIndexRoute
}

const AuthedAdminUsersRouteChildren: AuthedAdminUsersRouteChildren = {
  AuthedAdminUsersUserIdRoute: AuthedAdminUsersUserIdRoute,
  AuthedAdminUsersIndexRoute: AuthedAdminUsersIndexRoute,
}

const AuthedAdminUsersRouteWithChildren =
  AuthedAdminUsersRoute._addFileChildren(AuthedAdminUsersRouteChildren)

interface AuthedAdminRouteChildren {
  AuthedAdminOrganizationsRoute: typeof AuthedAdminOrganizationsRouteWithChildren
  AuthedAdminUsersRoute: typeof AuthedAdminUsersRouteWithChildren
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminOrganizationsRoute: AuthedAdminOrganizationsRouteWithChildren,
  AuthedAdminUsersRoute: AuthedAdminUsersRouteWithChildren,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedOrganizationsOrgIdRouteChildren {
  AuthedOrganizationsOrgIdAssignedVsUnassignedRoute: typeof AuthedOrganizationsOrgIdAssignedVsUnassignedRoute
  AuthedOrganizationsOrgIdConversionByEngagementLevelRoute: typeof AuthedOrganizationsOrgIdConversionByEngagementLevelRoute
  AuthedOrganizationsOrgIdGapAnalysisRoute: typeof AuthedOrganizationsOrgIdGapAnalysisRoute
  AuthedOrganizationsOrgIdProspectsRoute: typeof AuthedOrganizationsOrgIdProspectsRoute
  AuthedOrganizationsOrgIdProspectsByCapacityRoute: typeof AuthedOrganizationsOrgIdProspectsByCapacityRoute
  AuthedOrganizationsOrgIdProspectsByEngagementRoute: typeof AuthedOrganizationsOrgIdProspectsByEngagementRoute
  AuthedOrganizationsOrgIdProspectsByGivingLevelRoute: typeof AuthedOrganizationsOrgIdProspectsByGivingLevelRoute
  AuthedOrganizationsOrgIdIndexRoute: typeof AuthedOrganizationsOrgIdIndexRoute
}

const AuthedOrganizationsOrgIdRouteChildren: AuthedOrganizationsOrgIdRouteChildren =
  {
    AuthedOrganizationsOrgIdAssignedVsUnassignedRoute:
      AuthedOrganizationsOrgIdAssignedVsUnassignedRoute,
    AuthedOrganizationsOrgIdConversionByEngagementLevelRoute:
      AuthedOrganizationsOrgIdConversionByEngagementLevelRoute,
    AuthedOrganizationsOrgIdGapAnalysisRoute:
      AuthedOrganizationsOrgIdGapAnalysisRoute,
    AuthedOrganizationsOrgIdProspectsRoute:
      AuthedOrganizationsOrgIdProspectsRoute,
    AuthedOrganizationsOrgIdProspectsByCapacityRoute:
      AuthedOrganizationsOrgIdProspectsByCapacityRoute,
    AuthedOrganizationsOrgIdProspectsByEngagementRoute:
      AuthedOrganizationsOrgIdProspectsByEngagementRoute,
    AuthedOrganizationsOrgIdProspectsByGivingLevelRoute:
      AuthedOrganizationsOrgIdProspectsByGivingLevelRoute,
    AuthedOrganizationsOrgIdIndexRoute: AuthedOrganizationsOrgIdIndexRoute,
  }

const AuthedOrganizationsOrgIdRouteWithChildren =
  AuthedOrganizationsOrgIdRoute._addFileChildren(
    AuthedOrganizationsOrgIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedOrganizationsOrgIdRoute: typeof AuthedOrganizationsOrgIdRouteWithChildren
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedOrganizationsOrgIdRoute: AuthedOrganizationsOrgIdRouteWithChildren,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  VerifyRoute: VerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
